import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NucleusConnectorNotifierContract } from '@nucleus/connector-admin-ui';
import { BaseComponent } from '@nucleus/ui-base';
import { AuditTraceComponent } from '@nucleus/audit-report-ui';

/**
 * NUC-179: TaskSense notifier adapter for @nucleus/connector-admin-ui. Bridges
 * the lib's NucleusConnectorNotifierContract into BaseComponent's snackbar /
 * confirm / access-deny plumbing. The audit-trail dialog is opened via MatDialog
 * against AuditTraceComponent from @nucleus/audit-report-ui, mirroring the
 * reference-data notifier adapter. The connector lib never imports TaskSense
 * code; everything reaches it via DI.
 */
@Injectable()
export class TasksenseConnectorNotifierAdapter
  extends BaseComponent
  implements NucleusConnectorNotifierContract {

  private matDialog: MatDialog = inject(MatDialog);

  success(message: string): void { super.showSuccess(message); }
  error(message: string):   void { super.showError(message); }
  override confirm(title: string, message: string): Promise<boolean> { return super.confirm(title, message); }
  accessDenied(): void { super.showAccessDeny(); }
  openAuditTrail(entityName: string, entityId: string | number): void {
    this.matDialog.open(AuditTraceComponent, {
      panelClass: 'bw-dialog-panel',
      width: '1100px',
      maxWidth: '95vw',
      height: '72vh',
      data: { entityName, entityId }
    });
  }
}
